import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'
import {
  HelpCircle as HelpCircleIcon,
  Link as LinkIcon,
  PlusCircle as PlusCircleIcon,
} from 'react-feather'
import { Box, Button, Tooltip } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { isEmpty } from 'lodash'

import {
  Container,
  ContentHeader,
  DriveTour,
  ExternalLinkDialog,
  FilterButton,
  Filters,
  NewAiInventoryDialog,
  Page,
  Permitted,
} from 'components'

import AiInventoryTable from './components/AiInventoryTable'

import useDaiPermissions from 'hooks/useDaiPermissions'
import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'

import constants from 'constants/index'
import { routes } from 'Routes'
import * as service from 'service'
import useStyles from './styles'

const AiInventoryMain = () => {
  const classes = useStyles()

  const [openExternalLink, setOpenExternalLink] = useState(false)
  const [openTour, setOpenTour] = useState(false)
  const [newDialogOpen, setNewDialogOpen] = useState(false)

  const history = useHistory()
  const filter = useFilter()
  const { permitted: daiPermitted } = useDaiPermissions()

  const daiAllowed = daiPermitted(constants.dai.solutions.TAGS.AI_INVENTORY)

  const goToManualRegistration = () => history.push(routes.aiInventory.new)
  const goToDaiRegistration = () => history.push(routes.aiInventory.daiNew)

  // Com a DAI bloqueada por opt-out, só resta o cadastro manual — vai direto,
  // sem o diálogo de escolha.
  const handleNewAiInventory = () =>
    daiAllowed ? setNewDialogOpen(true) : goToManualRegistration()

  const { response: responseDepartments, isLoading: isLoadingDepartments } =
    useFetch(service.dponet.aiInventory.getDepartments, { order: 'name ASC' }, [
      filter.drawerOpen,
    ])

  const departments = responseDepartments?.data?.departments || []

  // Lista vazia significa que o usuário não está vinculado a nenhum
  // departamento — mesmo alerta exibido no formulário de cadastro de IA.
  const noEligibleDepartments =
    !isLoadingDepartments && !!responseDepartments && isEmpty(departments)

  const { RISK_OPTIONS } = constants.aiInventory

  return (
    <Page title="Inventário de IA">
      <Container maxWidth={false}>
        <ContentHeader title="Inventário de IA">
          <Button
            id={constants.aiInventory.AI_INVENTORY_MAIN_DRIVER_STEP_1}
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={() => setOpenTour(true)}
            fullWidth
          >
            Tutorial
          </Button>
          <Permitted
            tag={constants.permissions.AI_INVENTORY.MANAGE_GUEST_PORTAL}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<LinkIcon size={20} />}
              onClick={() => setOpenExternalLink(true)}
              fullWidth
            >
              Link Externo
            </Button>
          </Permitted>
          <Permitted tag={constants.permissions.AI_INVENTORY.MANAGE}>
            <Tooltip
              title={
                noEligibleDepartments
                  ? 'Seu usuário não está vinculado a nenhum departamento. Solicite a um responsável da empresa para liberar o cadastro de IA.'
                  : ''
              }
            >
              <span className={classes.newButtonWrapper}>
                <Button
                  id={constants.aiInventory.AI_INVENTORY_MAIN_DRIVER_STEP_2}
                  variant="contained"
                  color="primary"
                  startIcon={<PlusCircleIcon size={20} />}
                  onClick={handleNewAiInventory}
                  disabled={noEligibleDepartments}
                  fullWidth
                >
                  Nova IA
                </Button>
              </span>
            </Tooltip>
          </Permitted>
          <FilterButton
            id={constants.aiInventory.AI_INVENTORY_MAIN_DRIVER_STEP_3}
            setDrawerOpen={filter.setDrawerOpen}
            fullWidth
          />
        </ContentHeader>
        {noEligibleDepartments && (
          <Box mb={2}>
            <Alert variant="outlined" severity="warning">
              <strong>Nenhum departamento encontrado.</strong> Seu usuário não
              está vinculado a nenhum departamento, portanto não é possível
              cadastrar uma IA. Solicite a um responsável da empresa que vincule
              seu usuário a um departamento.
            </Alert>
          </Box>
        )}
        <div id={constants.aiInventory.AI_INVENTORY_MAIN_DRIVER_STEP_4}>
          <AiInventoryTable filter={filter} />
        </div>
      </Container>

      <Filters filter={filter}>
        <input textfieldinput="true" label="Nome" name="name" />
        <select
          autocompleteselectinput="true"
          label="Risco"
          name="risk"
          optionvalues={RISK_OPTIONS}
        />
        <select
          autocompleteselectinput="true"
          label="Departamento"
          name="departmentId"
          optionvalues={departments}
        />
      </Filters>

      <ExternalLinkDialog
        open={openExternalLink}
        setOpen={setOpenExternalLink}
        module="ai_inventory"
        managePermission={
          constants.permissions.AI_INVENTORY.MANAGE_GUEST_PORTAL
        }
      />
      <DriveTour
        stepsMatrix={constants.aiInventory.AI_INVENTORY_MAIN_DRIVER_STEPS}
        open={openTour}
        setOpen={setOpenTour}
      />

      <NewAiInventoryDialog
        open={newDialogOpen}
        setOpen={setNewDialogOpen}
        onSelectDai={goToDaiRegistration}
        onSelectManual={goToManualRegistration}
      />
    </Page>
  )
}

export default AiInventoryMain
